import { Link } from 'react-router-dom';
import type { Game } from '@/mocks/games';

interface GameCardProps {
  game: Game;
}

export default function GameCard({ game }: GameCardProps) {
  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/category/${game.category}`} className="block">
        <div className="relative w-full aspect-[16/10] overflow-hidden">
          <img
            src={game.image}
            alt={game.name}
            title={`${game.name} - 黄油游戏库独立游戏推荐`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          {game.isNew && (
            <span className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
              新游
            </span>
          )}
          {game.isHot && (
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
              热门
            </span>
          )}
        </div>
      </Link>
      <div className="p-4">
        <Link to={`/category/${game.category}`} className="block">
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1 mb-1.5">
            {game.name}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
          {game.description}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-primary-500 text-xs"></i>
            </div>
            <span className="text-sm font-semibold text-foreground-800">{game.rating}</span>
            <span className="text-xs text-foreground-400">({(game.ratingCount / 1000).toFixed(0)}k)</span>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {game.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}